import EventEmitter from "./event-emitter";

export default class FormModule {
    constructor(props = {}) {
        this.props = props;
        this.$root = this.props.$root;
        this.$nextButtons = Array.from(this.$root.querySelectorAll('[data-form="next"]'));

        this.name = this.props.name;
        this.fieldControllers = this.props.fieldControllers || [];
        this.subscriptions = this.props.subscriptions || [];
        this.eventEmitter = new EventEmitter(this.subscriptions);

        this.ACTIVE_MODULE_CHANGE_EVENT = 'activeModuleChange';
        this.FIELD_VALUE_CHANGE_EVENT = 'fieldValueChange';

        this.init();
    }

    init() {
        for (const $nextButton of this.$nextButtons) {
            const name = $nextButton.dataset.name;
            const validate = $nextButton.dataset.validate === 'true';

            if (!name) {
                continue;
            }

            if (validate && !this.getValidationStatus()) {
                $nextButton.disabled = true;
            }

            $nextButton.addEventListener('click', (e) => {
                e.preventDefault();

                if (validate && !this.getValidationStatus()) {
                    return;
                }

                this.eventEmitter.dispatch(this.ACTIVE_MODULE_CHANGE_EVENT, { name });
            });
        }

        this.fieldControllers.forEach((field) => {
            field.subscribe(field.VALUE_CHANGE_EVENT, (value) => {
                this.eventEmitter.dispatch(this.FIELD_VALUE_CHANGE_EVENT, { name: field.name, value });
            });

            field.subscribe(field.VALIDATION_STATUS_CHANGE_EVENT, () => {
                for (const $nextButton of this.$nextButtons) {
                    const name = $nextButton.dataset.name;
                    const validate = $nextButton.dataset.validate === 'true';

                    if (!name || !validate) {
                        continue;
                    }

                    $nextButton.disabled = !this.getValidationStatus();
                }
            });
        });

        this.eventEmitter.subscribe(this.ACTIVE_MODULE_CHANGE_EVENT, this._handleModuleActivated.bind(this));

        if (this.$root.dataset.active === 'true') {
            this._handleModuleActivated();
        }
    }

    getValidationStatus() {
        if (!this.fieldControllers.length) {
            return true;
        }

        return this.fieldControllers.every((field) => field.valid);
    }

    _handleModuleActivated() {}
}